import services from "../services";
export const tracePaymentActions = {
    getTracePayments,
    initiateTrace,
};

function getTracePayments(values, props) {
    return services.tracePaymentService.getTracePayments(values, props);
}

function initiateTrace(values, props) {
    return services.tracePaymentService.initiateTrace(values, props);
}


